import React from 'react';
import { SectionHead } from './ui/SectionHead';
import { SectionReveal } from './ui/SectionReveal';
import { engagements } from '../data/engagements';
export function Engagements() {
  return <section id="work" className="border-t border-rule py-[clamp(66px,9vw,114px)]" data-id="element-49" data-mp="1qstdedi4xubf">
      <div className="mx-auto max-w-shell px-[clamp(20px,5vw,64px)]" data-id="element-50" data-mp="1luruptomfx0h">
        <SectionHead index="01" kicker="Engagements" title="Two ways to work together." intro="One is a product your team runs continuously. The other is me, for a fixed window, on a specific problem. Most organizations start with the second and end up buying the first." data-id="element-51" data-mp="1lsf4kt8pmgcc" />

        <div className="mt-[52px] grid grid-cols-1 gap-px border border-rule bg-rule md:grid-cols-2" data-id="element-52" data-mp="24l99svgj6u3d">
          {engagements.map((engagement, i) => <SectionReveal key={engagement.title} delay={i * 0.06} className="bg-bone p-[clamp(26px,3.4vw,42px)]" data-id="element-53" data-mp="y5yxzv06dl4t" data-mpi={i}>
              <p className="font-mono text-[11px] uppercase tracking-[0.14em] text-ink-45" data-id="element-54" data-mp="25drl1quklb7r">
                {engagement.kicker}
              </p>
              <h3 className="mt-3.5 font-serif text-[clamp(20px,2.2vw,25px)] font-medium leading-[1.2] tracking-[-0.015em]" data-id="element-55" data-mp="2a9gldweeyw54">
                {engagement.title}
              </h3>
              <p className="mt-3.5 text-[15.5px] text-ink-70" data-id="element-56" data-mp="20bsgidn3g898">
                {engagement.description}
              </p>

              <ul className="mt-[26px]" data-id="element-57" data-mp="1mkdyoa4xad3r">
                {engagement.points.map(point => <li key={point} className="relative border-t border-rule-soft py-[11px] pl-[22px] text-[14.5px] text-ink-70" data-id="element-58" data-mp="1rerx6levt0cn">
                    <span aria-hidden="true" className="absolute left-0 top-[19px] h-px w-[9px] bg-signal" data-id="element-59" data-mp="1hl1bfoa5340n" />
                    {point}
                  </li>)}
              </ul>

              <a href={engagement.href} {...engagement.external ? {
            target: '_blank',
            rel: 'noopener noreferrer'
          } : {}} className="mt-7 inline-block border-b border-signal pb-[3px] font-mono text-[12px] uppercase tracking-[0.08em] text-signal transition-opacity duration-200 ease-editorial hover:opacity-70" data-id="element-60" data-mp="3acoekqgi8rfi">
                {engagement.linkLabel}
              </a>
            </SectionReveal>)}
        </div>
      </div>
    </section>;
}